require('frontend-controller/client/run')(
    require('./clientAppConfig'),
    {
        templates:      require.context('./components/', true, /^\.\/(base\/(errors?|form|bootstrap\d*|accordion)[^/]*\/|section|collection|templates\/events\/).*\.ejs$/),
        components:     require.context('./components/', true, /^\.\/(base\/(errors?|form|bootstrap\d*|accordion)[^/]*\/|section|collection|templates\/events\/).*\.js$/),
        styles:         require.context('./components/', true, /^\.\/(base\/(errors?|form|bootstrap\d*|accordion)[^/]*\/|section|collection|templates\/events\/).*\.less$/),
        translations:   require.context('./i18next/', true, /^\.\/.*\.js$/),
    },
    () => {
        // init vendors
        require('frontend-controller/styles/icons/fa62.less')
    }
)